exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-15cf58da],h2[data-v-15cf58da],p[data-v-15cf58da]{margin:0}#titleDiv[data-v-15cf58da]{background-image:url(https://dev.mysticgurus.club/wp-content/uploads/2022/02/woodsign.svg);background-position:50%;background-repeat:no-repeat;background-size:contain;text-align:center}#titleDiv #titleH2[data-v-15cf58da]{font-weight:600;text-shadow:2px 2px 3px rgb(255 255 255/50%);font-family:Architects Daughter;padding-top:10px;color:#333}#titleDiv #titleH1[data-v-15cf58da]{font-weight:600;text-shadow:2px 2px 3px rgb(255 255 255/30%);font-family:Architects Daughter;color:#333}#yourH2[data-v-15cf58da]{color:#fff;text-align:center;font-family:Architects Daughter;margin-top:10px}#layoutRow[data-v-15cf58da]{margin-top:30px}@media only screen and (max-width:1300px){#layoutRow .col-sm-4[data-v-15cf58da]{min-width:400px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15cf58da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MyAura/index.vue
// module id = 656
// module chunks = 0